import React, { Component } from 'react'
import axios from 'axios';
import logo from '../../images/brand-logo-image-light.png';
import '../../reclutamiento.css';


let cancelToken;
const fuente_referido = 2;  //id para referido
const subfuente_referido = 5;   //id para subfuente referido staff
let pending_submit = true;
let sending = false;


class Reclutamiento extends Component{

    constructor(props) {
        super(props);
        this.state ={
            zona_id: '',
            centro_id: '',
            nombre: '',
            correo: '',
            telefono: '',
            fuente_id: '',
            subfuente_id: '',
            referido_por: '',
            grado_estudios: '',
            nombre_carrera: '',
            perfil_facebook: 'required',
            perfil_instagram: 'required',
            perfil_twitter: '',
            curriculum: '',
            fuentes: [],
            zonas: [],
            centros: [],
            subfuentes: [],
            show_referido: false,
            req_facebook: 'required',
            req_instagram: 'required',
            submit_disabled: "",
            error_submit: false,
            msg_error: "",
            succes_submit: false
        }
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentDidMount() {
        this.getFuentes();
        this.getZonas();
    }

    // Obtener opciones para select de fuentes y zonas
        getFuentes = () => {
            let params = {};
            params.token_id = this.props.getTokenId();
            this.props.post(
                '/getFuentes', params, 
                (response) => this.didGetFuentes(response),
                (code, error_type, conekta_msj, msg) => this.errorWS(code, 'fuentes', conekta_msj, msg), cancelToken
            );
        }

        didGetFuentes = (response) => {   this.setState({ fuentes: response });   }


        getZonas = () => {
            let params = {};
            params.token_id = this.props.getTokenId();
            this.props.post(
                '/getZonas', params, 
                (response) => this.didGetZonas(response),
                (code, error_type, conekta_msj, msg) => this.errorWS(code, 'zonas', conekta_msj, msg), cancelToken
            );
        }

        didGetZonas = (response) => {   this.setState({ zonas: response });   }

    // Obtener opciones para select de centro y subfuente dependiendo de la opción seleccionada
        handleChangeZona = (event) => {
            let zona_id = event.target.value;
            this.setState({['zona_id']: zona_id});


            let params = {};
            params.token_id = this.props.getTokenId();
            params.zona_id = zona_id;
            this.props.post(
                '/getCentrosByZona', params, 
                (response) => this.didGetCentros(response),
                (code, error_type, conekta_msj, msg) => this.errorWS(code, 'centros', conekta_msj, msg), cancelToken
            );
        }

        didGetCentros = (response) => {  this.setState({ centros: response, centro_id:"" });  }

        
        handleChangeFuente = (event) => {
            let fuente_id = event.target.value;
            this.setState({['fuente_id']: fuente_id});


            let params = {};
            params.token_id = this.props.getTokenId();
            params.fuente_id = fuente_id;
            this.props.post(
                '/getSubfuentes', params, 
                (response) => this.didGetSubfuentes(response, fuente_id),
                (code, error_type, conekta_msj, msg) => this.errorWS(code, 'subfuentes', conekta_msj, msg), cancelToken
            );
        }

        didGetSubfuentes = (response, fuente_id) => {
            //Validamos si la fuente es referido para mostrar el campo de nombre
            let show_referido = (fuente_id == fuente_referido) ? true : false;
            let subfuente_id = (fuente_id == fuente_referido) ? 5 : "";

            this.setState({ subfuentes: response, show_referido: show_referido, subfuente_id: subfuente_id, referido_por: "" });
        }

    //Error en WS al obtener opciones para inputs
        errorWS = (code, error_type, conekta_msj, msg) => {
            let ws_error_msg = 'Ocurrió un error al cargar información de '+error_type+'. Por favor refresca la página e inténtalo de nuevo.';
            window.scrollTo({top: 7000,left: 0,behavior: "smooth"});
            this.setState({error_submit: true, msg_error: ws_error_msg});
        }


    // Agregar valor del formulario a objeto state como argumentos para ws
        handleInputChange = (event) => {
            let input = event.target.name;
            this.setState({[input]: event.target.value});
        }

    //Adjuntar curriculum
        handleChangeCurriculum = (event) => {
            let file = event.target.files[0];

            if(file.size > 5000000){
                //No permitir documentos de más de 5 mb
                event.target.value = null;
                this.setState({error_submit: true, msg_error: "El tamaño del archivo es demasiado grande. Por favor agrega un archivo de 5mb o menor."});
            }else{
                this.setState({curriculum: file, error_submit: false, msg_error:''});
            }
            
        }

    //Quitar requerido a campo de perfil instagram si se llena el de facebook
        handleChangeFacebook = (event) => {
            if(event.target.value){
                this.setState({req_instagram: ''});
            }else{
                this.setState({req_instagram: 'required'});
            }
            this.setState({perfil_facebook: event.target.value});
        }

    //Quitar requerido a campo de facebook instagram si se llena el de instagram
        handleChangeInstagram = (event) => {
            if(event.target.value){
                this.setState({req_facebook: ''});
            }else{
                this.setState({req_facebook: 'required'});
            }
            this.setState({perfil_instagram: event.target.value});
        }

    //Envío de formulario
        submitForm = (event) => {
            event.preventDefault();
            if(pending_submit){
                pending_submit = false;
                this.setState({submit_disabled: 'disabled', sending: true}, ()=>{this.addCandidato(this.state);} );
            }
        }

        addCandidato = (current_state) => {

            let params = new FormData();

            params.append("token_id", this.props.getTokenId());
            params.append("zona_id", this.state.zona_id);
            params.append("centro_id", this.state.centro_id);
            params.append("nombre", this.state.nombre);
            params.append("correo", this.state.correo);
            params.append("telefono", this.state.telefono);
            params.append("fuente_id", this.state.fuente_id);
            params.append("subfuente_id", this.state.subfuente_id);
            params.append("referido_por", this.state.referido_por);
            params.append("grado_estudios", this.state.grado_estudios);
            params.append("nombre_carrera", this.state.nombre_carrera);
            params.append("perfil_facebook", this.state.perfil_facebook);
            params.append("perfil_instagram", this.state.perfil_instagram);
            params.append("perfil_twitter", this.state.perfil_twitter);
            params.append("curriculum", this.state.curriculum);
            params.append("usuario_creo", null);
            params.append("candidato_status_id", 7); //estatus de aplicación

            if(!pending_submit && !sending){
                sending = true;
                this.props.post(
                    '/addCandidato', params, 
                    (response) => this.successAddCandidato(response),
                    (code, error_type, conekta_msj, msg) => this.errorWS(code, 'formulario', conekta_msj, msg), cancelToken
                )
            }    
        }

        successAddCandidato = (response) => {
            this.setState({succes_submit: true});
        }


    render () {
        return(
            <div>
                <div className="panel-body">
                <div className = "container-fluid">
                    <div className="panel panel-default">
                        <div className="panel-heading text-center" style={{background: 'linear-gradient(32deg, rgba(255,255,255,1) 0%, rgba(69,194,228,1) 1%, rgba(235, 75, 210) 100%)'}}>
                            <div className="navbar-brand" style={{paddingTop: '10px'}}>
                                <img alt="IOS OFFICES" className="brand-logo" src={logo} />
                            </div>
                            <h4 className="panel-title" style={{fontSize: 'x-large', color: '#fff'}}>ÚNETE AL EQUIPO IOS</h4>
                        </div>
                        <div className="panel-body text-left">
                            <form id="form_candidato" method="post" onSubmit={this.submitForm}>
                                <fieldset>
                                    <div className="row">

                                        <div className="col-md-12">

                                            <div className="form-group">
                                                <label htmlFor="nombre">NOMBRE COMPLETO</label>
                                                <input className="form-control" id="nombre" name="nombre" placeholder="Nombre" type="text" required onChange={this.handleInputChange}/>
                                            </div>

                                        </div>

                                        <div className="col-md-6">

                                            <div className="form-group">
                                                <label htmlFor="correo">CORREO ELECTRÓNICO</label>
                                                <input className="form-control" id="correo" name="correo" placeholder="Correo" type="email" required  onChange={this.handleInputChange}/>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="grado_estudios">SELECCIONA TU GRADO DE ESTUDIOS</label>
                                                <select className="form-control" id="grado_estudios" name="grado_estudios" defaultValue="" required onChange={this.handleInputChange}>
                                                    <option value="" disabled hidden style={select_placeholder}>Seleciona una opción</option>
                                                    <option value="4">Preparatoria</option>
                                                    <option value="3">Carrera Tecnica</option>
                                                    <option value="1">Título Profesional</option>
                                                    <option value="2">Maestria</option>
                                                </select>
                                            </div>
                                            
                                            <div className="form-group">
                                                <label htmlFor="perfil_facebook">ENLACE A TU PERFIL DE FACEBOOK</label>
                                                <input className="form-control" id="perfil_facebook" name="perfil_facebook" placeholder="Enlace" required={this.state.req_facebook} onChange={this.handleChangeFacebook} />
                                            </div>
                                            
                                            <div className="form-group">
                                                <label htmlFor="perfil_twitter">ENLACE A TU PERFIL DE TWITTER</label>
                                                <input className="form-control" id="perfil_twitter" name="perfil_twitter" placeholder="Enlace" onChange={this.handleInputChange} />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="zona_id">SELECCIONA UNA ZONA</label>
                                                <select className="form-control" id="zona_id" name="zona_id" defaultValue="" required onChange={this.handleChangeZona}>
                                                    <option value="" disabled hidden style={select_placeholder}>Seleciona una opción</option>
                                                    {this.state.zonas.map((zona, index) =>
                                                        <option key={index} value={zona.valor}>{zona.zona}</option>
                                                    )}
                                                </select>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="fuente_id">¿CÓMO NOS ENCONTRASTE?</label>
                                                <select className="form-control" id="fuente_id" name="fuente_id" defaultValue="" required onChange={this.handleChangeFuente}>
                                                    <option value="" disabled hidden style={select_placeholder}>Seleciona una opción</option>
                                                    {this.state.fuentes.map((fuente, index) =>
                                                        <option key={index} value={fuente.valor}>{fuente.fuente}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            
                                            <div className="form-group">
                                                <label htmlFor="telefono">TELÉFONO</label>
                                                <input className="form-control" id="telefono" name="telefono" placeholder="Telefono"  type="tel" required onChange={this.handleInputChange} />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="nombre_carrera">NOMBRE DE TU CARRERA</label>
                                                <input className="form-control" id="nombre_carrera" name="nombre_carrera" placeholder="Nombre" type="text" required onChange={this.handleInputChange}/>
                                            </div>
                                            
                                            <div className="form-group">
                                                <label htmlFor="perfil_instagram">ENLACE A TU PERFIL DE INSTAGRAM</label>
                                                <input className="form-control" id="perfil_instagram" name="perfil_instagram" placeholder="Enlace" required={this.state.req_instagram} onChange={this.handleChangeInstagram} />
                                            </div>
                                            
                                            <div className="form-group">
                                                <label htmlFor="curriculum">ADJUNTA TU CURRICULUM</label>
                                                <input
                                                    style={file_input}
                                                    id="curriculum"
                                                    name="curriculum"
                                                    type="file"
                                                    accept="application/pdf, .pdf, application/msword, .doc, .docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                    required
                                                    onChange={this.handleChangeCurriculum}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="centro_id">SELECCIONA UN CENTRO</label>
                                                
                                                {
                                                    ( !this.state.centros.length ) ? 

                                                    <select className="form-control" defaultValue="" required>
                                                        <option value="" disabled hidden >Es necesario seleccionar una zona</option>
                                                    </select>

                                                    :

                                                    <select className="form-control" id="centro_id" name="centro_id" defaultValue="" value={this.state.centro_id} required onChange={this.handleInputChange}>
                                                        <option value="" disabled hidden style={select_placeholder}>Seleciona una opción</option>
                                                        {this.state.centros.map((centro, index) =>
                                                            <option key={index} value={centro.valor}>{centro.centro}</option>
                                                        )}
                                                    </select>

                                                }

                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="subfuente_id">ESPECIFICA</label>
                                                
                                                {
                                                    ( !this.state.subfuentes.length ) ?

                                                    <select className="form-control" defaultValue="" required>
                                                        <option value="" disabled hidden >Es necesario seleccionar una fuente</option>
                                                    </select>

                                                    :

                                                    <span>
                                                        <select className="form-control" id="subfuente_id" name="subfuente_id" style={{display: this.state.show_referido? 'none' : 'block'}} value={this.state.subfuente_id} required onChange={this.handleInputChange}>
                                                            <option value="" disabled hidden style={select_placeholder}>Seleciona una opción</option>
                                                            {this.state.subfuentes.map((subfuente, index) =>
                                                                <option key={index} value={subfuente.Valor}>{subfuente.Subfuente}</option>
                                                            )}
                                                        </select>

                                                        <input className="form-control" id="referido_por" name="referido_por" style={{display: this.state.show_referido? 'block' : 'none'}} value={this.state.referido_por} placeholder="Nombre" required={this.state.show_referido? 'required' : ''} onChange={this.handleInputChange} />
                                                    </span>

                                                }

                                            </div>

                                        </div>



                                        <div className="col-xs-12">

                                            {this.state.succes_submit && this.submitSucces()}
                                            {this.state.error_submit && this.submitError()}
                                            {!this.state.error_submit && !this.state.succes_submit && (pending_submit || !sending) && this.submitButton()}

                                        </div>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div> 
            </div>
            </div>
        );
    }

    // Botón para envío del formulario
    submitButton = () => {
        return (
            <div className="panel-body col-xs-12" style={{textAlign: "center"}}>
                <center>
                    <table>
                        <tbody>
                        <tr>
                            <td>
                                <button 
                                    className={"btn btn-lg btn-primary "+this.state.submit_disabled}
                                    type="submit"
                                    readOnly={this.state.submit_disabled}
                                    onClick={this.handleClick}
                                    style={{background: 'linear-gradient(32deg, rgba(255,255,255,1) 0%, rgba(69,194,228,1) 1%, rgba(235, 75, 210) 100%)', border: '0px'}}
                                >
                                    {this.state.submit_disabled ? 'ENVIANDO...' : 'ENVIAR'}
                                </button>
                            </td>
                            <td>&emsp;</td>
                            <td><div className="loader" style={{display: this.state.submit_disabled? 'block' : 'none'}}></div></td>
                        </tr>
                        </tbody>
                    </table>
                </center>
            </div>
        );
    }

    // Error en submit
    submitError = () => {
        return (
            <div className="form-group col-xs-12">
                <br/>
                <p style={errorMessage}><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> {this.state.msg_error}</p>
            </div>
        );
    }

    // Mensaje de suscripcion exitosa
    submitSucces = () => {
        return (
            <div className="form-group col-xs-12">
                <br/>
                <p style={succesMessage}><i className="fa fa-check-square" aria-hidden="true"></i> {this.state.nombre}, tu información se envió de forma exitosa</p>
                {/*<p style={succesMessage}>(Los detalles se te enviaran por medio de un correo electrónico)</p>*/}
            </div>
        );
    }

    

}

export default (Reclutamiento);

// Css aditinal site
const select_placeholder = {color: 'gray !important'}
const succesMessage = {color: '#50cfb4', fontSize: 'larger', textAlign: 'center'}
const errorMessage = {color: '#f27428', fontSize: 'larger', textAlign: 'center'}
const file_input = {height: '34px', padding:"6px 12px"}



// WEBPACK FOOTER //
// ./src/guest/reclutamiento/Reclutamiento.js